import { Map as map } from 'immutable';
const C = require("../constants");

function ModalProductStockReducer(state = map(), action) {
    switch (action.type) {
        case C.PRODUCT_STOCK_UPDATE_MODAL:
            return action.modal;
        default:
            return state;
    }
}

export default ModalProductStockReducer;


// WEBPACK FOOTER //
// ./src/reducers/ModalProductStockUpdateReducer.js